import { render } from "./result.vue?vue&type=template&id=286cf5de&ts=true"
import script from "./result.vue?vue&type=script&setup=true&lang=ts"
export * from "./result.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/init/components/result.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "286cf5de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('286cf5de', __exports__)) {
    console.log('reload')
    api.reload('286cf5de', __exports__)
  }
  
  module.hot.accept("./result.vue?vue&type=template&id=286cf5de&ts=true", () => {
    console.log('re-render')
    api.rerender('286cf5de', render)
  })

}


export default __exports__